import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Spinner from 'react-bootstrap/Spinner';
import Modal from "react-bootstrap/Modal";
import InputGroup from "react-bootstrap/InputGroup";
import {
  resetPassword,
  verifyResetPasswordToken,
} from "../services/authService";
import * as formik from "formik";
import * as Yup from "yup";
import AlertCustom from "../components/AlertCustom/AlertCustom";

const ResetPassword = () => {
  let { token } = useParams();
  console.log(token);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordChecks, setPasswordChecks] = useState({
    length: false,
    lowercase: false,
    uppercase: false,
    number: false,
    specialChar: false,
  });

  const PasswordToggle = (e) => {
    e.preventDefault();
    setShowPassword((prevState) => !prevState);
  };
  const { Formik } = formik;
  const [show, setShow] = useState(false);

  // useEffect(() => {
  //   handleShow()
  // },[])
  const checkPasswordStrength = (password) => {
    const checks = {
      length: password.length >= 8,
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      number: /\d/.test(password),
      specialChar: /[@$!%*?&#]/.test(password),
    };
    setPasswordChecks(checks);
  };

  const validationSchema = Yup.object({
    password: Yup.string()
      .min(8, "Minimum 8 characters")
      .matches(/[a-z]/, "At least one lowercase letter")
      .matches(/[A-Z]/, "At least one uppercase letter")
      .matches(/\d/, "At least one number")
      .matches(/[@$!%*?&#]/, "At least one special character")
      .required("Password is required"),
    language: Yup.string(),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const navigate = useNavigate();
  const handleClose = () => {
    setShow(false);
    navigate("/", { replace: true });
  };
  const handleShow = () => setShow(true);
  const handleSubmit = async (values) => {
    setLoading(true);
    setNotification();

    const data = {
      confirm_password: values.confirmPassword,
      new_password: values.password,
      language: "en",
    };
    console.log("data", data);
    try {
      const res = await resetPassword(data, token);
      console.log("Reset Password successful:", res);
      // setNotification(<AlertCustom message={res?.message ?? 'something went wrong'} variant="success" />)
      handleShow();
      setNotification(
        <AlertCustom
          message={res?.message ?? "something went wrong"}
          variant="success"
        />
      );

      // navigate('/', { replace: true });
    } catch (error) {
      console.error("Authentication failed:", error.response.data.message);
      setNotification(
        <AlertCustom
          message={error?.response?.data?.message ?? "something went wrong"}
          variant="danger"
        />
      );
    } finally {
      setLoading(false);
    }
  };

  const verifyTokenBeforeUse = async () => {
    try {
      await verifyResetPasswordToken(token);
    } catch (error) {
      console.log("Token verification failed: ", error.response.data.message);
      setNotification(
        <AlertCustom
          message={error.response.data.message ?? "something went wrong"}
          variant="danger"
        />
      );
    }
  };

  useEffect(() => {
    verifyTokenBeforeUse();
  }, []);

  return (
    <>
      <div className="text-center">
        <h1 className="fs-1 fw-bold text-gray-700 mb-2">Choose New Password</h1>
        <h2 className="fs-5 fw-normal text-gray-500">
          Almost Done!, Enter your new password &
          <br className="d-none d-lg-block" /> you're all set
        </h2>
      </div>
      <Formik
        validationSchema={validationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleSubmit}
        initialValues={{ password: "", confirmPassword: "", language: "en" }}
      >
        {({ handleSubmit, handleChange, values, touched, errors }) => (
          <Form className="mt-5" onSubmit={handleSubmit}>
            {notification}
            <Form.Group className="mb-4" controlId="formBasicPassword">
              <Form.Label>New Password</Form.Label>
              <div className="input-warpper lock-icon">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  // value={values.password}
                  name="password"
                  onChange={(e) => {
                    handleChange(e);
                    checkPasswordStrength(e.target.value);
                  }}
                  isInvalid={!!errors.password}
                />
                <button
                  type="button"
                  className="input-group-icon btn-reset right"
                  onClick={PasswordToggle}
                >
                  <Image
                    src={
                      showPassword ? "/images/eye-off.svg" : "/images/eye.svg"
                    }
                    width={20}
                    height={20}
                    alt="Eye Icon"
                  />
                </button>
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            <Form.Group className="mb-4" controlId="formBasicPassword">
              <Form.Label>Confirm New Password</Form.Label>
              <div className="input-warpper lock-icon">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter confirm password"
                  // value={values.confirmPassword}
                  name="confirmPassword"
                  onChange={handleChange}
                  isInvalid={!!errors.confirmPassword}
                />
                <button
                  type="button"
                  className="input-group-icon btn-reset right"
                  onClick={PasswordToggle}
                >
                  <Image
                    src={
                      showPassword ? "/images/eye-off.svg" : "/images/eye.svg"
                    }
                    width={20}
                    height={20}
                    alt="Eye Icon"
                  />
                </button>
                <Form.Control.Feedback type="invalid">
                  {errors.confirmPassword}
                </Form.Control.Feedback>
              </div>
            </Form.Group>

            <Form.Group className="check-green">
              <Form.Check
                className="mb-2"
                type="checkbox"
                label="Minimum 8 characters"
                checked={passwordChecks.length}
              />
              <Form.Check
                className="mb-2"
                type="checkbox"
                label="One lower & upper case characters "
                checked={passwordChecks.lowercase && passwordChecks.uppercase}
              />
              <Form.Check
                className="mb-2"
                type="checkbox"
                label="One special character"
                checked={passwordChecks.specialChar}
              />
              <Form.Check
                className="mb-2"
                type="checkbox"
                label="One number"
                checked={passwordChecks.number}
              />
            </Form.Group>

            <Button type="submit" className="btn btn-primary w-100 mt-5" disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : "Reset Password" }
            </Button>
          </Form>
        )}
      </Formik>

      <p className="text-center mt-2">
        <Link
          to="/auth/login"
          className="text-gray-700 fw-semibold text-decoration-none"
        >
          Cancel
        </Link>
      </p>

      <Modal className="info-modal" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/lock-icon-with-shape.svg" alt="Lock Icon" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Password Updated Successfully!
            </h2>
            <p className="fs-5 text-gray-500 fw-normal mb-0">
              Your password has been updated. Let's log in again.
            </p>
            <Button
              className="btn bntn-primary w-100 mt-5"
              onClick={handleClose}
            >
              Okay, Great!
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ResetPassword;
